import { take } from "../../util";
export const fromGql = (item) => (Object.assign({}, take(item, 'id', 'name', 'imageUrl', 'soundchartsUuid')));
export const fromGqlCollection = (items) => (items || []).map(item => fromGql(item));
//# sourceMappingURL=SearchResultArtist.js.map